/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon16Regular = forwardRef('MediaUiAPlayPauseIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12 2.25a.75.75 0 0 1 .75.75v10a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.25 3.64a1.35 1.35 0 0 1 2.115-1.112l6.34 4.36a1.35 1.35 0 0 1 0 2.224l-6.34 4.36a1.35 1.35 0 0 1-2.115-1.113V3.641Zm1.5 8.434L8.676 8 2.75 3.926v8.148Z" }),
        React.createElement("path", { d: "M15.75 3a.75.75 0 0 0-1.5 0v10a.75.75 0 0 0 1.5 0V3Z" })));
});
